/**
 * Generated by orval v7.9.0 🍺
 * Do not edit manually.
 * IntakeApp
 * OpenAPI spec version: v1
 */

export type FormFieldAssignee = typeof FormFieldAssignee[keyof typeof FormFieldAssignee];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const FormFieldAssignee = {
  Patient: 'Patient',
  Clinician: 'Clinician',
} as const;
